import { SharedService } from './../../services/shared/shared.service';
import { Component, OnInit, Input } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { LabelService } from 'src/app/services/label/label.service';
import { encodeURL } from 'src/app/services/parseURL';
import { Storage } from '@ionic/storage';

@Component({
    selector: 'app-category-grid',
    templateUrl: './category-grid.component.html',
    styleUrls: ['./category-grid.component.scss'],
})
export class CategoryGridComponent implements OnInit {
    @Input() list: any;
    @Input() listType: string;
    @Input() subcatParentId: string;
    @Input() title: string;
    CO_CATEGORY_GRID_LABELS: any = {};

    constructor(private router: Router,
        private labelService: LabelService,
        private sharedService: SharedService,
        private storage: Storage) { }

    ngOnInit() {
        this.CO_CATEGORY_GRID_LABELS = this.labelService.labels['CO_CATEGORY_GRID'];
    }


    async openService(item) {
        const res = await this.sharedService.checkLoginStatus(`${this.CO_CATEGORY_GRID_LABELS['must_be_user_to_access_services_msg']}`);
        if (res) {
            const navigationExtras: NavigationExtras = {
                state: {
                    serviceData: item
                }
            };
            this.router.navigate(['service-response'], navigationExtras);
        }
    }

    urlName(name: string) {
        return encodeURL(name);
    }

    async setExclusive(item) {
        if (this.listType === 'categories') {
            // this.sharedService.manageExclusiveCategories(item.isExclusive || false, item.id, 'parentCategory');
        }

        if(this.listType === 'subcategories') {
            // let exclusiveObj = await this.storage.get('exclusiveObj');
            // const isExclusive = exclusiveObj.categoryType === 'parentCategory' && exclusiveObj.exclusivity ? false : item.isExclusive;
            // this.sharedService.manageExclusiveCategories(isExclusive || false, item.id, 'subCategory');
        }
    }

}
